export default __webpack_public_path__ + "static/media/fee-info-icon.80615c36.svg";